import { object, string } from "zod";

export const loginResolver = object({
    email: string({ required_error: "Email is required" })
        .email()
        .nonempty({ message: "Email is required." }),
    password: string({ required_error: "Password is required" })
        .nonempty({ message: "Password is required." }),
});
